// "Bekijk als" (pilot 26-10, baan 2B): beheer kan alles zien wat een gebruiker
// ziet, zonder in te loggen als een ander.
//
// De stand (rol + propositie) leeft in dit tabblad (sessionStorage) en reist
// als twee koppen mee met elke vraag aan de dienst (`lib/api.ts`). De dienst
// neemt ze ALLEEN over als de ingelogde persoon beheer is; bij iedereen anders
// doen ze niets. Er is geen identiteitswissel: de sessie blijft die van beheer.
//
// Wisselen herlaadt de pagina: dan vraagt elk scherm zijn gegevens opnieuw op
// in de nieuwe stand, in plaats van dat een half scherm nog de oude toont.

export type BekijkAlsRol = "am" | "bp" | "beheer";
export type BekijkAlsStand = { rol: BekijkAlsRol; propositie: string | null } | null;

const SLEUTEL = "sof.bekijkAls";
const ROLLEN: readonly BekijkAlsRol[] = ["am", "bp", "beheer"];

export const KOP_ROL = "X-Bekijk-Als-Rol";
export const KOP_PROPOSITIE = "X-Bekijk-Als-Propositie";

/** De woorden op het scherm. */
export const ROL_WOORD: Record<BekijkAlsRol, string> = {
  beheer: "Beheer",
  am: "Accountmanager (AM)",
  bp: "Opleidingsmanager (BP)",
};

function lees(): BekijkAlsStand {
  try {
    const ruw = globalThis.sessionStorage?.getItem(SLEUTEL);
    if (!ruw) return null;
    const s = JSON.parse(ruw) as { rol?: unknown; propositie?: unknown };
    if (typeof s.rol !== "string" || !ROLLEN.includes(s.rol as BekijkAlsRol)) return null;
    const propositie = typeof s.propositie === "string" && /^[a-z][a-z0-9_]*$/.test(s.propositie) ? s.propositie : null;
    return { rol: s.rol as BekijkAlsRol, propositie };
  } catch {
    return null;
  }
}

let stand: BekijkAlsStand = lees();

/** De stand van dit tabblad, of null (de eigen stand). */
export function bekijkAls(): BekijkAlsStand {
  return stand;
}

/** Zet (of wis, met null) de stand. Standaard herlaadt de pagina. */
export function zetBekijkAls(nieuw: BekijkAlsStand, herlaad = true): void {
  stand = nieuw;
  try {
    if (nieuw) globalThis.sessionStorage?.setItem(SLEUTEL, JSON.stringify(nieuw));
    else globalThis.sessionStorage?.removeItem(SLEUTEL);
  } catch {
    // privévenster of geblokkeerde opslag: de stand geldt dan tot het herladen
  }
  if (herlaad && typeof window !== "undefined") window.location.reload();
}

/** De koppen voor elke vraag aan de dienst; leeg in de eigen stand. */
export function bekijkAlsKoppen(): Record<string, string> {
  if (!stand) return {};
  return {
    [KOP_ROL]: stand.rol,
    ...(stand.propositie ? { [KOP_PROPOSITIE]: stand.propositie } : {}),
  };
}
